<template>
	<div style="display: none;">
		<img v-if="inStock" src="/img/icons/product_calendar.svg" alt="icon calender">
		<p v-if="inStock" class="text mt-1 mb-1">
			Leverans
			<span v-if="isLoggedIn" class="semibold">{{ earliestDelivery }}</span>
			<span v-if="! isLoggedIn" class="semibold">1-2 dagar</span>
		</p>
		<img src="/img/icons/product_truck.svg" alt="icon truck">
		<p class="text mt-1 mb-1">
			<span v-if="textIndex === 0"> Fri frakt. Hämta gratis i butik.</span>
			<span v-if="textIndex === 1"> Fri hemleverans.  Hämta gratis i butik.</span>
			<span v-if="textIndex === 2"> {{ shippingPriceFrom }} </span>
		</p>
		<img src="/img/icons/product_return.svg" alt="icon return">
		<p class="mt-1 mb-1">30 dagars öppet köp</p>
	</div>
</template>

<script>

import { mapGetters, mapState } from 'vuex';
import store from 'datastore';
import { isEmpty } from 'lodash';
import bus from 'eventbus';
import format from 'date-fns/format';
import svLocale from 'date-fns/locale/sv';


export default {
	store,
	props: {
		product: {
			type: Object,
			required: true,
		},
		shippingPriceFrom: {
			type: String,
			required: true,
		}
	},
	data () {
		return {
			filteredMethods: {},
		};
	},
	computed: {
		...mapState({
			deliveryDates: state => state.user.deliveryDates,
			earliestDelivery:  state => state.user.earliestDeliveryDate,
			fetched: state => state.user.deliveryDates.fetched,
		}),
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
			userZipCode: 'user/hasZipCode',
		}),
		price () {
			return this.product.price.price;
		},
		textIndex () {
			let textIndex = '';

			if (this.isLoggedIn) {
				textIndex = this.price >= 500 ? 1 : 0;
			}
			if (! this.isLoggedIn) {
				textIndex = 2;
			}

			return textIndex;
		},
		inStock () {
			return this.product.stock.web > 0;
		},
		now () {
			const date = Date.now();
			return format(date, 'dddd', { locale: svLocale });
		},
	},
	watch: {
		deliveryDates (to, frm) {
			if (! isEmpty(to)) {
				this.checkDeliveryConstraints();
			}
		},
		// Needed for switching between products
		product (to, frm) {
			if (! isEmpty(frm)) {
				this.checkDeliveryConstraints();
			}
		},
		//Prevents infinite loop
		filteredMethods (to, frm) {
			if (! isEmpty(to)) {
				this.$store.commit('user/updateEarliestDeliveryDate', this.filteredMethods);
			}
		},
		now () {
			this.getDeliveryDates();
		}
	},
	mounted () {
		this.getDeliveryDates();
		this.checkDeliveryConstraints();
	},
	methods: {
		checkDeliveryConstraints () {
			if (this.inStock) {
				const deliveryMethods = this.product.possibleDeliveryMethods;
				const methods = deliveryMethods.toString();
				const shipFromStore = this.product.stock.isSentFromStore > 0;
				const methodShipFromStore = ['1', '3'];
				const shippingMethods = shipFromStore ? methodShipFromStore : methods;
				const filteredMethods = {};

				// Check id on delivery options against delivery constraints. Filter out id, rebuild object and commit to store.
				Object.entries(this.deliveryDates).forEach(([key, value]) => {
					filteredMethods[key] = Object.keys(value).filter(key =>
							shippingMethods.includes(key)).reduce((obj, key) => {
						obj[key] = value[key];
						return obj;
					}, {});
				});

				this.filteredMethods = filteredMethods;
			};
		},
		// New request after midnight
		getDeliveryDates () {
			if (this.userZipCode && this.now > this.fetched)  {
				this.$store.dispatch('user/getDeliveryDates', this.userZipCode)
			}
		},
	},
};

</script>

